import React from 'react';
import moment from 'moment';
import CustomDatePicker from '../../../../../Components/Utility/DatePicker/DatePicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getControlStyle } from '../../../../../Components/helper';
import CommonAction from './CommonAction';

export function DatePickerElement({
  label,
  fromForm,
  duplicatingItem,
  gridIndex,
  pageIndex,
  disable,
  editingInput,
  showDelete,
  deleteItem,
  value,
  onChange,
  placeHolder,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  setParentGridZIndex,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  boldLabel,
  gridY,
  fontSize,
  range,
}) {
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };
  const combinedStyles = getControlStyle(otherConfiguration);

  const handleCalendarOpen = () => {
    setParentGridZIndex(true, gridIndex);
  };

  const handleCalendarClose = () => {
    setParentGridZIndex(false, gridIndex);
  };

  const style = fontSize?.value ? { fontSize: `${fontSize?.value}px` } : {};

  return (
    <div className="dt_picker position-relative">
      <p style={style} className={`asterisk-req ${!fontSize?.value && 'fs-custom-module'} mb-0 ${fromForm && 'd-flex'} ${boldLabel && 'font-weight-bold'}`}>
        {label}
      </p>

      <CustomDatePicker
        keyProp={`_${gridIndex}_${pageIndex}`}
        dateFormat={range ? 'dd-MMM-yy' : 'dd-MMM-yyyy'}
        popperPlace={gridY > 30 ? 'top' : 'bottom'}
        disable={disable}
        name="selectedDate"
        placeholder={placeHolder}
        onCalendarClose={handleCalendarClose}
        onCalendarOpen={handleCalendarOpen}
        valueProp={value}
        style={combinedStyles}
        fontSize={fontSize}
        onChange={(e) => onChange(range ? e : moment(new Date(e)).format('DD-MMM-YYYY'), label, gridIndex, pageIndex)}
        isRange={range}
        startDate={range ? value?.[0] : null}
        endDate={range ? value?.[1] : null}
      />
      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
    </div>
  );
}
export default DatePickerElement;
